<template>
    <div id="app">
        <router-view class="app-home"/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        mounted() {
            // 阻止调试
            setInterval(function () {
                debugger
            }, 100);
        },
        watch: {
            $route: {
                handler:function(val, oldVal){
                    this.$nextTick(() => {  //页面加载完成后执行
                        // 如果打开设备是移动端
                        if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
                            // 并且当前页面不是移动端首页则跳转
                            if (this.$route.path !== "/index-mobile") {
                                this.$router.push("/index-mobile");
                            }
                        } else {
                            // 如果不是移动端当前页面又在移动端首页则跳转
                            if (this.$route.path === "/index-mobile") {
                                this.$router.push("/index");
                            }
                        }
                    })
                },
                // 深度观察监听
                deep: true
            }
        }
    }
</script>

<style>
    @import "./assets/css/main.css";
</style>



// WEBPACK FOOTER //
// src/App.vue